/**
 * Scroller
 *
 * Scroll towards target on click.
 */
(function( $ )
{
	"use strict";

	    // Smooth Scrolling
        $(document).ready(function(){
            $('a[href*="#"]:not([href="#"])').click(function() {
                if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                    if (target.length) {
                        $('html, body').velocity('stop').velocity('scroll', { offset: target.offset().top - 150, mobileHA: false });
                        return false;
                    }
                }
            }); 
        });

})( jQuery );
